import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/landing/desktop/clients/Clients.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/landing/desktop/FAQDesktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/landing/desktop/reels/Feed.tsx");
;
import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/src/components/landing/desktop/services/ServiceList.tsx");
;
import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/src/components/landing/desktop/why/WhyForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/pages/admin-dashboard/recent-works/RecentWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/pages/admin-dashboard/text-testimonal/TextTestimonal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/ui/separator.tsx");
